import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from '@starling/core/auth/store';
import { useLightFeaturesQuery } from '@/features/hooks';

// Гард приватных маршрутов. Если пользователь не аутентифицирован — редирект
// на /login с сохранением пути возврата в location.state.from.
export function ProtectedRoute(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

// Гард раздела «Владелец платформы» (`/platform/*`, M5.4). Пропускает только
// platform_admin; тенантные роли (admin/employee) редиректим на их домашнюю
// страницу — раздел платформы им не виден и недоступен.
export function RequirePlatformAdmin(): JSX.Element {
  const role = useAuthStore((s) => s.user?.role);
  if (role !== 'platform_admin') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

// Гард тенантной админки. platform_admin живёт вне тенантского контекста —
// у него нет тенантских данных, поэтому его редиректим в раздел платформы.
export function RequireTenantUser(): JSX.Element {
  const role = useAuthStore((s) => s.user?.role);
  if (role === 'platform_admin') {
    return <Navigate to="/platform" replace />;
  }
  return <Outlet />;
}

/**
 * Гард раздела «Объявления» по тумблеру платформы (доводка V1 №19):
 * флаг выключен → на главную. Пока флаги грузятся — пропускаем (fail-open,
 * см. `features/hooks.ts`); прямой заход по URL при выключенном разделе
 * редиректит после загрузки.
 */
export function RequireListingsFeature(): JSX.Element {
  const { data } = useLightFeaturesQuery();
  if (data && !data.listings_enabled) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
